exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/authoring.js-WebpackMultiOutput";